import { computed as e, createVNode as t, defineComponent as r, isVNode as o, mergeProps as n, onMounted as s, onUnmounted as i, ref as l, watch as c } from "vue";

var {min: a, max: u, abs: f, floor: d} = Math, p = (e, t, r) => a(r, u(t, e)), m = e => [ ...e ].sort((e, t) => e - t), g = setTimeout, h = "function" == typeof queueMicrotask ? queueMicrotask : e => {
    Promise.resolve().then(e);
}, S = () => {
    let e;
    return [ new Promise(t => {
        e = t;
    }), e ];
}, b = e => {
    let t;
    return () => (e && (t = e(), e = void 0), t);
}, _ = e => e.documentElement, v = e => e.ownerDocument, z = e => e.defaultView, y = /*#__PURE__*/ b(() => !!/iP(hone|od|ad)/.test(navigator.userAgent) || "MacIntel" === navigator.platform && navigator.maxTouchPoints > 0), $ = /*#__PURE__*/ b(() => "scrollBehavior" in _(document).style), x = ({t: e, o: t, i: r, l: o, u: n, p: s, m: i, h: l, S: c, v: d}, p = 0) => {
    let m = !!d, g = !!p, h = 1, S = 0, b = 0, _ = 0, v = 0, z = 0, $ = 0, x = 0, I = 0, w = null, O = [ 0, g ? u(p - 1, 0) : -1 ], k = 0, j = !1;
    const N = /* @__PURE__ */ new Set, q = () => _ - b, B = () => q() + z + v, E = (e, t) => {
        const n = r(e) - z;
        return t ? i() - n - o(e) : n;
    }, R = e => {
        e && (y() && 0 !== x || w && 1 === I ? z += e : v += e);
    };
    return {
        I: () => {
            N.clear();
        },
        O: () => h,
        t: (t = 200) => {
            if (!j || g) return O;
            let r, o;
            if ($) [r, o] = O; else {
                let n = u(0, B()), s = n + S;
                m || (t = u(0, t), 1 !== x && (n -= t), 2 !== x && (s += t)), [r, o] = O = e(u(0, n), u(0, s)), 
                w && (r = a(r, w[0]), o = u(o, w[1]));
            }
            return [ u(r, 0), a(o, l() - 1) ];
        },
        k: e => t(e - b),
        j: s,
        i: E,
        l: o,
        N: l,
        q: () => _,
        B: () => 0 !== x,
        R: () => S,
        T: () => b,
        m: i,
        M: () => ($ = v, v = 0, [ $, 2 === I ]),
        P: (e, t) => {
            const r = [ e, t ];
            return N.add(r), () => {
                N.delete(r);
            };
        },
        A: (r, l) => {
            let a, u, p = 0;
            switch (r) {
              case 1:
                {
                    if (l === _ && 0 === I) break;
                    const e = $;
                    $ = 0;
                    const t = l - _, r = f(t);
                    e && r < f(e) + 1 || 0 !== I || (x = t < 0 ? 2 : 1), g && (g = !1), _ = l, p = 4;
                    const o = q();
                    o >= -S && o <= i() && (p += 1, u = r > S);
                    break;
                }

              case 2:
                p = 8, 0 !== x && (a = !0, p += 1), x = 0, I = 0, w = null;
                break;

              case 3:
                {
                    const e = l.filter(([e, t]) => !s(e, t));
                    if (!e.length) break;
                    R(e.reduce((e, [t, r]) => {
                        let n;
                        if (2 === I) n = !0; else if (w && 1 === I) n = t < w[0]; else {
                            const e = q(), r = E(t), s = o(t);
                            n = 1 !== x && 0 === I ? r + s <= e : r < e && r + s < e + S;
                        }
                        return n && (e += r - o(t)), e;
                    }, 0));
                    for (const [t, r] of e) {
                        const e = o(t), s = n(t, r);
                        m && (k += s ? r : r - e);
                    }
                    m && S && k > S && (R(d(t(B()))), m = !1), p = 3, u = !0;
                    break;
                }

              case 4:
                S !== l && (S || (j = u = !0), S = l, p = 3);
                break;

              case 5:
                l[1] ? (R(c(l[0], !0)), I = 2, p = 1) : (c(l[0]), p = 1);
                break;

              case 6:
                b = l;
                break;

              case 7:
                I = 1;
                break;

              case 8:
                w = e(l, l + S), p = 1;
            }
            p && (h = 1 + (2147483647 & h), a && z && (v += z, z = 0), N.forEach(([e, t]) => {
                p & e && t(u);
            }));
        }
    };
}, I = (e, t, r, o = 0, n = t - 1) => {
    let s = o;
    for (;o <= n; ) {
        const t = d((o + n) / 2);
        e(t) <= r ? (s = t, o = t + 1) : n = t - 1;
    }
    return p(s, 0, t - 1);
}, w = (e, t, r) => {
    const o = r ? "unshift" : "push";
    for (let r = 0; r < t; r++) e[o](-1);
    return e;
}, O = (e, t, r) => {
    let o = r && r[1] || t || 40, n = -1, s = 0;
    const i = r && r[0], l = i ? w(i.slice(0, a(e, i.length)), u(0, e - i.length)) : w([], e), c = w([], e + 1), f = e => {
        const t = l[e];
        return -1 === t ? o : t;
    }, d = t => {
        if (!e) return 0;
        if (n >= t) return c[t];
        n < 0 && (c[0] = 0, n = 0);
        let r = n, o = c[r];
        for (;r < t; ) o += f(r), c[++r] = o;
        return n = t, o;
    };
    return {
        t: (t, r) => {
            let o, n;
            return s = a(s, e - 1), d(s) <= t ? (n = I(d, e, r, s), o = I(d, e, t, s, n)) : (o = I(d, e, t, void 0, s), 
            n = I(d, e, r, o)), s = o, [ o, n ];
        },
        o: t => I(d, e, t),
        i: d,
        l: f,
        u: (e, t) => {
            const r = -1 === l[e];
            return l[e] = t, n = a(e, n), r;
        },
        p: (e, t = -1) => l[e] === t,
        m: () => d(e),
        h: () => e,
        S: (t, r) => {
            const s = t - e;
            return n = r ? -1 : a(t - 1, n), e = t, s > 0 ? (w(c, s), w(l, s, r), o * s) : (c.splice(s), 
            (r ? l.splice(0, -s) : l.splice(s)).reduce((e, t) => e - (-1 === t ? o : t), 0));
        },
        v: t ? void 0 : e => {
            let t = 0;
            const r = [];
            l.forEach((o, n) => {
                -1 !== o && (o && r.push(o), n < e && t++);
            }), n = -1;
            const s = m(r), i = s.length, c = i / 2 | 0, a = i % 2 == 0 ? (s[c - 1] + s[c]) / 2 : s[c], f = o;
            return ((o = a) - f) * u(e - t, 0);
        },
        C: () => [ l.slice(), o ]
    };
}, k = e => {
    let t;
    return {
        L(r) {
            (t || (t = new (z(v(r)).ResizeObserver)(e))).observe(r);
        },
        V(e) {
            t.unobserve(e);
        },
        H() {
            t && t.disconnect();
        }
    };
}, j = (e, t) => t ? -e : e, N = (e, t, r, o, n, s) => {
    const i = Date.now;
    let l = 0, c = !1, a = !1, u = !1, f = !1;
    const d = (() => {
        let t;
        const r = () => {
            null != t && clearTimeout(t);
        }, o = () => {
            r(), t = g(() => {
                t = null, (() => {
                    if (c || a) return c = !1, void d();
                    u = !1, e.A(2);
                })();
            }, 150);
        };
        return o.F = r, o;
    })(), p = () => {
        l = i(), u && (f = !0), s && e.A(6, s()), e.A(1, o()), d();
    }, m = t => {
        if (c || !e.B() || t.ctrlKey) return;
        const o = i() - l;
        150 > o && 50 < o && (r ? t.deltaX : t.deltaY) && (c = !0);
    }, h = () => {
        a = !0, u = f = !1;
    }, S = () => {
        a = !1, y() && (u = !0);
    };
    return t.addEventListener("scroll", p), t.addEventListener("wheel", m, {
        passive: !0
    }), t.addEventListener("touchstart", h, {
        passive: !0
    }), t.addEventListener("touchend", S, {
        passive: !0
    }), {
        H: () => {
            t.removeEventListener("scroll", p), t.removeEventListener("wheel", m), t.removeEventListener("touchstart", h), 
            t.removeEventListener("touchend", S), d.F();
        },
        D: () => {
            const [t, r] = e.M();
            t && (n(t, r, f), f = !1, r && e.R() > e.m() && e.A(1, o()));
        }
    };
}, q = (e, t, r) => {
    let o;
    return [ async (n, s) => {
        if (!await t()) return;
        o && o();
        const i = () => {
            const [t, r] = S();
            return o = () => {
                r(!1);
            }, e.R() && g(o, 150), [ t, e.P(2, () => {
                r(!0);
            }) ];
        };
        if (s && $()) e.A(8, n()), h(async () => {
            for (;;) {
                let t = !0;
                for (let [r, o] = e.t(); r <= o; r++) if (e.j(r)) {
                    t = !1;
                    break;
                }
                if (t) break;
                const [r, o] = i();
                try {
                    if (!await r) return;
                } finally {
                    o();
                }
            }
            e.A(7), r(n(), s);
        }); else for (;;) {
            const [t, o] = i();
            try {
                if (e.A(7), r(n()), !await t) return;
            } finally {
                o();
            }
        }
    }, () => {
        o && o();
    } ];
}, B = (e, t) => {
    e.X(() => t);
}, E = (e, t, r, {align: o, smooth: n, offset: s = 0} = {}) => {
    if (r = p(r, 0, t.N() - 1), "nearest" === o) {
        const e = t.i(r), n = t.q();
        if (e < n) o = "start"; else {
            if (!(e + t.l(r) > n + t.R())) return;
            o = "end";
        }
    }
    e.X(() => s + e.Y() + t.i(r) + ("end" === o ? t.l(r) - (t.R() - e.J()) : "center" === o ? (t.l(r) - (t.R() - e.J())) / 2 : 0), n);
}, R = /* @__PURE__ */ r({
    props: {
        W: {
            type: Object,
            required: !0
        },
        U: {
            type: Object,
            required: !0
        },
        G: {
            type: Object,
            required: !0
        },
        K: {
            type: Function,
            required: !0
        },
        Z: {
            type: Number,
            required: !0
        },
        ee: {
            type: Boolean
        },
        te: {
            type: Boolean
        },
        re: {
            type: Boolean
        },
        oe: {
            type: String,
            required: !0
        },
        ne: Object
    },
    setup(r) {
        const s = l(), i = e(() => r.W.value && r.U.i(r.Z, r.re)), a = e(() => r.W.value && r.U.j(r.Z));
        return c(() => s.value && r.Z, (e, t, o) => {
            o(r.K(s.value, r.Z));
        }, {
            flush: "post"
        }), () => {
            const {G: e, ee: l, te: c, oe: u} = r, f = a.value, {style: d, ...p} = r.ne ?? {}, m = {
                contain: "layout style",
                position: f && c ? void 0 : "absolute",
                [l ? "height" : "width"]: "100%",
                [l ? "top" : "left"]: "0px",
                [l ? "left" : "top"]: i.value + "px",
                visibility: !f || c ? void 0 : "hidden",
                ...d
            };
            return l && (m.display = "inline-flex"), t(u, n({
                ref: s,
                style: m
            }, p), "function" == typeof (g = e) || "[object Object]" === Object.prototype.toString.call(g) && !o(g) ? e : {
                default: () => [ e ],
                _: 2
            }, 16, [ "style" ]);
            var g;
        };
    }
}), T = (e, t) => {
    if (1 === e.length) {
        const t = e[0].key;
        if (null != t) return t;
    }
    return "_" + t;
}, M = (e, t) => e[0] === t[0] && e[1] === t[1], P = /* @__PURE__ */ r({
    props: {
        data: {
            type: Array,
            required: !0
        },
        bufferSize: Number,
        itemSize: Number,
        shift: Boolean,
        horizontal: Boolean,
        startMargin: {
            type: Number,
            default: 0
        },
        ssrCount: Number,
        scrollRef: Object,
        as: {
            type: String,
            default: "div"
        },
        item: {
            type: String,
            default: "div"
        },
        itemProps: Function,
        keepMounted: Array,
        cache: Object
    },
    emits: [ "scroll", "scrollEnd" ],
    setup(r, {emit: n, expose: a, slots: f}) {
        let d = !!r.ssrCount;
        const p = r.horizontal, h = l(), b = O(r.data.length, r.itemSize, r.cache), _ = x(b, r.ssrCount), v = ((e, t) => {
            let r, o, n = S(), s = !1;
            const i = t ? "scrollLeft" : "scrollTop", l = t ? "overflowX" : "overflowY", [c, a] = q(e, () => n[0], (e, o) => {
                e = j(e, s), o ? r.scrollTo({
                    [t ? "left" : "top"]: e,
                    behavior: "smooth"
                }) : r[i] = e;
            }), u = t ? "width" : "height", f = /* @__PURE__ */ new WeakMap, d = k(t => {
                const o = [];
                for (const {target: n, contentRect: s} of t) if (n.offsetParent) if (n === r) e.A(4, s[u]); else {
                    const e = f.get(n);
                    null != e && o.push([ e, s[u] ]);
                }
                o.length && e.A(3, o);
            });
            return {
                se(c, u = c.parentElement) {
                    d.L(r = u), t && (s = "rtl" === getComputedStyle(u).direction), o = N(e, u, t, () => j(u[i], s), (t, r, o) => {
                        if (o) {
                            const e = u.style, t = e[l];
                            e[l] = "hidden", g(() => {
                                e[l] = t;
                            });
                        }
                        u[i] = j(e.q() + t, s), r && a();
                    }), n[1](!0);
                },
                I() {
                    d.H(), o && o.H(), n[1](!1), n = S();
                },
                ie: (e, t) => (f.set(e, t), d.L(e), () => {
                    f.delete(e), d.V(e);
                }),
                le: () => s,
                X: c,
                ce() {
                    o && o.D();
                },
                Y: e.T,
                J: () => 0
            };
        })(_, p), z = l(_.O());
        _.P(1, () => {
            z.value = _.O();
        }), _.P(4, () => {
            n("scroll", _.q());
        }), _.P(8, () => {
            n("scrollEnd");
        });
        const y = e(e => {
            z.value;
            const t = _.t(r.bufferSize);
            return e && M(e, t) ? e : t;
        }), $ = e(() => z.value && _.B()), I = e(() => z.value && _.m());
        return s(() => {
            d = !1;
            const e = h.value, t = requestAnimationFrame(() => {
                v.se(e, r.scrollRef);
            });
            i(() => {
                cancelAnimationFrame(t);
            });
        }), i(() => {
            _.I(), v.I();
        }), c(() => r.data.length, e => {
            _.A(5, [ e, r.shift ]);
        }), c(() => r.startMargin, e => {
            _.A(6, e);
        }, {
            immediate: !0
        }), c([ z ], () => {
            v.ce();
        }, {
            flush: "post"
        }), a({
            get cache() {
                return b.C();
            },
            get scrollOffset() {
                return _.q();
            },
            get scrollSize() {
                return (e => u(e.m(), e.R()))(_);
            },
            get viewportSize() {
                return _.R();
            },
            findItemIndex: _.k,
            getItemOffset: _.i,
            getItemSize: _.l,
            scrollToIndex: (e, t) => E(v, _, e, t),
            scrollTo: e => B(v, e),
            scrollBy: e => ((e, t, r) => {
                B(e, r + t.q());
            })(v, _, e)
        }), () => {
            const e = r.as, n = r.item, s = I.value, i = v.le(), l = [], c = e => {
                const o = f.default({
                    item: r.data[e],
                    index: e
                });
                return t(R, {
                    key: T(o, e),
                    W: z,
                    U: _,
                    K: v.ie,
                    Z: e,
                    G: o,
                    ee: p,
                    re: i,
                    te: d,
                    oe: n,
                    ne: r.itemProps?.({
                        item: r.data[e],
                        index: e
                    })
                }, null, 8, [ "W", "U", "K", "Z", "G", "ee", "re", "te", "oe", "ne" ]);
            };
            if (r.keepMounted) {
                const e = new Set(r.keepMounted);
                for (let [t, r] = y.value; t <= r; t++) e.add(t);
                m([ ...e ]).forEach(e => {
                    l.push(c(e));
                });
            } else for (let [e, t] = y.value; e <= t; e++) l.push(c(e));
            return t(e, {
                ref: h,
                style: {
                    contain: "size style",
                    overflowAnchor: "none",
                    flex: "none",
                    position: "relative",
                    width: p ? s + "px" : "100%",
                    height: p ? "100%" : s + "px",
                    pointerEvents: $.value ? "none" : void 0
                }
            }, "function" == typeof (a = l) || "[object Object]" === Object.prototype.toString.call(a) && !o(a) ? l : {
                default: () => [ l ],
                _: 2
            }, 8, [ "style" ]);
            var a;
        };
    }
}), A = /* @__PURE__ */ r({
    props: {
        data: {
            type: Array,
            required: !0
        },
        bufferSize: Number,
        itemSize: Number,
        shift: Boolean,
        horizontal: Boolean,
        ssrCount: Number,
        itemProps: Function,
        keepMounted: Array,
        cache: Object
    },
    emits: [ "scroll", "scrollEnd" ],
    setup(e, {emit: r, expose: n, slots: s}) {
        const i = e.horizontal, c = e => {
            r("scroll", e);
        }, a = () => {
            r("scrollEnd");
        }, u = l();
        return n({
            get cache() {
                return u.value.cache;
            },
            get scrollOffset() {
                return u.value.scrollOffset;
            },
            get scrollSize() {
                return u.value.scrollSize;
            },
            get viewportSize() {
                return u.value.viewportSize;
            },
            findItemIndex: (...e) => u.value.findItemIndex(...e),
            getItemOffset: (...e) => u.value.getItemOffset(...e),
            getItemSize: (...e) => u.value.getItemSize(...e),
            scrollToIndex: (...e) => u.value.scrollToIndex(...e),
            scrollTo: (...e) => u.value.scrollTo(...e),
            scrollBy: (...e) => u.value.scrollBy(...e)
        }), () => {
            return t("div", {
                style: {
                    display: i ? "inline-block" : "block",
                    [i ? "overflowX" : "overflowY"]: "auto",
                    contain: "strict",
                    width: "100%",
                    height: "100%"
                }
            }, [ t(P, {
                ref: u,
                data: e.data,
                bufferSize: e.bufferSize,
                itemSize: e.itemSize,
                itemProps: e.itemProps,
                shift: e.shift,
                ssrCount: e.ssrCount,
                horizontal: i,
                keepMounted: e.keepMounted,
                cache: e.cache,
                onScroll: c,
                onScrollEnd: a
            }, (r = s, "function" == typeof r || "[object Object]" === Object.prototype.toString.call(r) && !o(r) ? s : {
                default: () => [ s ],
                _: 2
            }), 8, [ "data", "bufferSize", "itemSize", "itemProps", "shift", "ssrCount", "horizontal", "keepMounted", "cache", "onScroll", "onScrollEnd" ]) ], 4);
            var r;
        };
    }
}), C = /* @__PURE__ */ r({
    props: {
        data: {
            type: Array,
            required: !0
        },
        bufferSize: Number,
        itemSize: Number,
        ssrCount: Number,
        shift: Boolean,
        horizontal: Boolean,
        as: {
            type: String,
            default: "div"
        },
        item: {
            type: String,
            default: "div"
        },
        cache: Object
    },
    emits: [ "scroll", "scrollEnd" ],
    setup(r, {emit: n, slots: a, expose: u}) {
        let f = !!r.ssrCount;
        const d = r.horizontal, p = l(), m = O(r.data.length, r.itemSize, r.cache), g = x(m, r.ssrCount), b = ((e, t) => {
            let r, o, n, s = S(), i = !1;
            const l = t ? "left" : "top", [c] = q(e, () => s[0], (e, t) => {
                e = j(e, i);
                const o = z(v(r));
                t ? o.scroll({
                    [l]: e,
                    behavior: "smooth"
                }) : o.scroll({
                    [l]: e
                });
            }), a = t ? "width" : "height", u = /* @__PURE__ */ new WeakMap, f = k(t => {
                const r = [];
                for (const {target: e, contentRect: o} of t) {
                    if (!e.offsetParent) continue;
                    const t = u.get(e);
                    null != t && r.push([ t, o[a] ]);
                }
                r.length && e.A(3, r);
            }), d = (e, t, r, o, n = 0) => {
                const s = o ? "offsetLeft" : "offsetTop", l = n + (o && i ? r.innerWidth - e[s] - e.offsetWidth : e[s]), c = e.offsetParent;
                return e !== t && c ? d(c, t, r, o, l) : l;
            };
            return {
                se(c) {
                    r = c;
                    const a = t ? "scrollX" : "scrollY", u = v(c), f = z(u), p = () => {
                        e.A(4, f[t ? "innerWidth" : "innerHeight"]);
                    };
                    f.addEventListener("resize", p), h(p), n = () => {
                        f.removeEventListener("resize", p);
                    }, t && (i = "rtl" === getComputedStyle(_(u)).direction), o = N(e, f, t, () => j(f[a], i), (t, r) => {
                        r ? f.scroll({
                            [l]: j(e.q() + t, i)
                        }) : f.scrollBy({
                            [l]: j(t, i)
                        });
                    }, () => d(c, u.body, f, t)), s[1](!0);
                },
                I() {
                    n && n(), f.H(), o && o.H(), r = void 0, s[1](!1), s = S();
                },
                ie: (e, t) => (u.set(e, t), f.L(e), () => {
                    u.delete(e), f.V(e);
                }),
                le: () => i,
                X: c,
                ce() {
                    o && o.D();
                },
                Y() {
                    const e = v(r);
                    return d(r, e.body, z(e), t);
                },
                J() {
                    const o = _(v(r));
                    return e.R() - (t ? o.clientWidth : o.clientHeight);
                }
            };
        })(g, d), y = l(g.O());
        g.P(1, () => {
            y.value = g.O();
        }), g.P(4, () => {
            n("scroll");
        }), g.P(8, () => {
            n("scrollEnd");
        });
        const $ = e(e => {
            y.value;
            const t = g.t(r.bufferSize);
            return e && M(e, t) ? e : t;
        }), I = e(() => y.value && g.B()), w = e(() => y.value && g.m());
        return s(() => {
            f = !1;
            const e = p.value;
            e && b.se(e);
        }), i(() => {
            g.I(), b.I();
        }), c(() => r.data.length, e => {
            g.A(5, [ e, r.shift ]);
        }), c([ y ], () => {
            b.ce();
        }, {
            flush: "post"
        }), u({
            get cache() {
                return m.C();
            },
            get scrollOffset() {
                return g.q();
            },
            get viewportSize() {
                return g.R();
            },
            findItemIndex: g.k,
            getItemOffset: g.i,
            getItemSize: g.l,
            scrollToIndex: (e, t) => E(b, g, e, t)
        }), () => {
            const e = r.as, n = r.item, s = w.value, i = b.le(), l = [];
            for (let [e, o] = $.value; e <= o; e++) {
                const o = a.default({
                    item: r.data[e],
                    index: e
                });
                l.push(t(R, {
                    key: T(o, e),
                    W: y,
                    U: g,
                    K: b.ie,
                    Z: e,
                    G: o,
                    ee: d,
                    re: i,
                    te: f,
                    oe: n
                }, null, 8, [ "W", "U", "K", "Z", "G", "ee", "re", "te", "oe" ]));
            }
            return t(e, {
                ref: p,
                style: {
                    contain: "size style",
                    overflowAnchor: "none",
                    flex: "none",
                    position: "relative",
                    width: d ? s + "px" : "100%",
                    height: d ? "100%" : s + "px",
                    pointerEvents: I.value ? "none" : void 0
                }
            }, "function" == typeof (c = l) || "[object Object]" === Object.prototype.toString.call(c) && !o(c) ? l : {
                default: () => [ l ],
                _: 2
            }, 8, [ "style" ]);
            var c;
        };
    }
});

export { A as VList, P as Virtualizer, C as WindowVirtualizer };
//# sourceMappingURL=index.js.map